<ng-container>
  <div class="indicator-wrapper pr-3 pt-3 is-flex">
    <div class="has-background-info-light updates-indicator tag is-link is-rounded text-inherit-fit" 
    data-e2e="updates-indicator">
      New Version Available
    </div>
  </div>
</ng-container>
